// Contants
import {DIRECTION_TYPES} from './cmsComponentContants'
import {CMS_COMPONENT_SOURCE_TYPES} from '../homePageComponents/homePageComponentsConstants'

function getDirection(type) {
  return DIRECTION_TYPES[type]
}

function getComponentsByDirection(components) {
  let groupedComponents = {
    horizontal: [],
    vertical: [],
    swimlane: [],
  }

  components.forEach(component => {
    let direction = getDirection(component.type)

    groupedComponents[direction].push(component)
  })

  return groupedComponents
}

const prepareRecommendationPayload = (components, bulkList) => {
  if (!components) {
    return []
  }

  return components.map(component => {
    const currentBulkList = bulkList.find(listItem => listItem.typeId?.toString() === component.id?.toString())

    return {
      typeId: currentBulkList?.typeId?.toString(),
      bannerList: currentBulkList?.bannerList?.map(banner => ({
        id: banner.id,
        fixedOrder: banner.fixedOrder,
        sortId: banner.sortId,
        content: {
          categoryIds: banner.categoryIds || null,
          segmentTags: banner.segmentTags || null
        }
      }))
    }
  }).filter(cmp => Boolean(cmp.bannerList))
}

function getChildIds(componentItem) {
  if (componentItem?.bannerList?.length) {
    const isSwimlane = getDirection(componentItem.type) === DIRECTION_TYPES.Swimlane
    let childIds = componentItem.bannerList.map((item) => item.id)

    if (isSwimlane) {
      childIds = childIds.slice(0, componentItem.itemCount)
    }

    return childIds.join(',')
  }

  return null
}

function setBannersEventDataToWindow(bannerList) {
  window.bannersEventData = {}

  bannerList?.filter((cmp) => cmp?.dataSource === CMS_COMPONENT_SOURCE_TYPES.CMS).forEach((cmp) => {
    cmp?.bannerList?.forEach((banner) => {
      const code = banner?.reason?.code

      if (code) {
        window.bannersEventData[banner.id] = {
          code
        }
      }
    })
  })
}

export {
  setBannersEventDataToWindow,
  getDirection,
  prepareRecommendationPayload,
  getChildIds,
  getComponentsByDirection
}
